import { render, staticRenderFns } from "./ApprovalsForbidden.vue?vue&type=template&id=73619a42&"
import script from "./ApprovalsForbidden.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ApprovalsForbidden.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports